import { analytics } from 'config';
import { fireLinkTag } from './tagManager';

const { payloadProperty } = analytics.price.details;
/**
 * Trigger analytics for details link
 * Payload property is a dynamic property that depends on brand
 * @param {StringToString} data
 * @returns {void}
 */

export function onDetailsClickAnalytics(data) {
  const linkData = {
    event_name: data.eventName,
    product_id: data.productId,
    [payloadProperty]: data[payloadProperty],
  };

  fireLinkTag(linkData);
}

export default onDetailsClickAnalytics;
